'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import MailSender from '../components/MailSender'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--forward'
        // Objects
        // Fns
        new MailSender(this.view)
    }
}

page = Barba.BaseView.extend({
    namespace: 'forward',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {

    },
    onLeave: function()
    {

    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;